import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from '../Navbar';
import Footer from '../Footer';
import Home from '../../routes/Home';
import About from '../../routes/About';
import Services from '../../routes/Services';
import ServiceModal from '../../routes/Services/ServiceModal';
import DoshaQuiz from '../../routes/DoshaQuiz';
import { useScrollToTop } from '../../hooks/useScrollToTop';

import './App.css';

function ScrollToTop() {
  useScrollToTop();
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col bg-warm-white">
        <Navbar />
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />}>
              <Route path=":name" element={<ServiceModal />} />
            </Route>
            <Route path="/about" element={<About />} />
            <Route path="/dosha-quiz" element={<DoshaQuiz />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
